import { render, staticRenderFns } from "./modalOtorgarCredito.vue?vue&type=template&id=542accf6&scoped=true&"
import script from "./modalOtorgarCredito.vue?vue&type=script&lang=js&"
export * from "./modalOtorgarCredito.vue?vue&type=script&lang=js&"
import style0 from "./modalOtorgarCredito.vue?vue&type=style&index=0&id=542accf6&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542accf6",
  null
  
)

export default component.exports